import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './Timeline.scss';

const Timeline = ({ title, points, activeIndex }) => {
    const [activePoint, setActivePoint] = useState(activeIndex);
    const pointsElement = useRef(null);

    const activatePoint = (e, index) => {
        const target = e.currentTarget;
        pointsElement.current.scroll({
            top: 0, 
            left: target.offsetLeft * 0.75, 
            behavior: 'smooth'
        });
        setActivePoint(index);
    };

    const point = points[activePoint];

    return (
        <div className="Timeline">
            {title && <h2 className="Timeline__HeaderTitle">{title}</h2>}
            <div className="Timeline__PointsContainer">
                <ul className="Timeline__Points" ref={pointsElement}>
                    {points.map((item, index) => {
                        return (
                            <li
                                className={classNames('Timeline__Point', {
                                    'Timeline__Point--Active': activePoint === index
                                })}
                                key={index}
                                onClick={(e) => activatePoint(e, index)}>
                                <span className="Timeline__Blob">
                                    <svg width="58" height="58" fill="none" viewBox="0 0 58 58">
                                        <path d="M31.287 57.575c-15.046 0-30.6-14.321-30.6-29.526S15.058.917 30.104.917c4.401 0 9.35 1.717 13.03 3.59 7.501.799 14.213 13.184 14.213 23.94 0 15.206-11.013 29.128-26.059 29.128z"/>
                                    </svg>
                                </span>
                                <span className="Timeline__PointTime">{item.time}</span>
                                <h2 className="Timeline__PointTitle">{item.title}</h2>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div className="Timeline__Content">
                <div className="Timeline__TextContainer">
                    {point && point.title &&
                        <h2 className="Timeline__Title">{point.title}</h2>
                    }
                    {point && point.text &&
                        <div className="Timeline__Text" dangerouslySetInnerHTML={{ __html: point.text }} />
                    }
                    {point && point.link &&
                        <a className="Timeline__Link" href={point.link}>{point.linkText}</a>
                    }
                </div>
                {point && point.image &&
                    <div className="Timeline__Image" style={{backgroundImage: `url(${point.image.sizes.mediumLarge})`}} />
                }
            </div>
        </div>
    );
};

Timeline.propTypes = {
    title: PropTypes.string,
    points: PropTypes.array,
    activeIndex: PropTypes.number,
};

Timeline.defaultProps = {
    points: [],
    activeIndex: 0
};

export default Timeline;
